import { sumBy, getOr, find, flow, filter, map } from 'lodash/fp';

const getInstallationPricing = (charges, specMappings = {}, excludeCharges = []) => {
  const getRetailFor = specName => flow(
    find({ specName }),
    getOr(0, 'retail'),
  );

  const excludeChargesSet = new Set(excludeCharges);

  const surcharges = flow(
    filter(({ retail }) => retail > 0),
    filter({ specType: 'Surcharge' }),
    filter(({ specName }) => !excludeChargesSet.has(specName)),
    map(s => ({
      ...s,
      displayName: getOr(s.specName, `${s.specName}.displayName`)(specMappings),
    })),
  )(charges);

  const measureCredit = getRetailFor('measurecredit')(charges);
  const hasInstallation = find({ specName: 'installation' })(charges);
  const installationCost = hasInstallation ? getRetailFor('installation')(charges) : getRetailFor('reinstall')(charges);
  const additionalInstallationCost = sumBy('retail')(surcharges);

  const totalInstallationCost = installationCost + additionalInstallationCost + measureCredit;

  return {
    measureCredit,
    installationCost,
    surcharges,
    additionalInstallationCost,
    totalInstallationCost,
  };
};
export default getInstallationPricing;
